module.exports = __webpack_public_path__ + "img/depositsIcon.f361e33f.png";